module.exports = __webpack_public_path__ + "static/media/cefta.96799b88.svg";